import cookie from 'js-cookie';

const PCI_PAL_AGENT_STORAGE_KEY = 'pcipal-agent';

export function getPciPalAgentCookie(): number | undefined {
  const rawCookie = cookie.get(PCI_PAL_AGENT_STORAGE_KEY);
  if (!rawCookie) {
    return undefined;
  }

  const parsedValue = parseInt(rawCookie);
  if (isNaN(parsedValue)) {
    return undefined;
  }

  return parsedValue;
}
